import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TransportOrderCardComponent } from './transport-order-card/transport-order-card.component';
import { LoadCardComponent } from './load-card/load-card.component';
import { LoadInfoBarModule } from '../../load-info-bar/load-info-bar.module';
import { StatusCodeModule } from '../../status-code/status-code.module';
import { IntrackFeatureModule } from '../../../intrack-feature.module';
import { RouterModule } from '@angular/router';
import { TransportModeModule } from '../../transport-mode/transport-mode.module';
import { TimezoneModule } from '../../timezone/timezone.module';
import { PipesModule } from '../../../common/pipes/pipes.module';
import { InfoFieldModule } from '../../info-field/info-field.module';
import { MonitoringDatesModule } from '../dates/monitoring-dates.module';
import { DeviationTypeModule } from '../../deviation-type';
import { SvgIconModule } from '../../svg-icon/svg-icon.module';

@NgModule({
  imports: [
    IntrackFeatureModule,
    RouterModule,
    TranslateModule.forChild({}),
    LoadInfoBarModule,
    StatusCodeModule,
    TransportModeModule,
    TimezoneModule,
    PipesModule,
    InfoFieldModule,
    MonitoringDatesModule,
    DeviationTypeModule,
    SvgIconModule,
  ],
  declarations: [TransportOrderCardComponent, LoadCardComponent],
  exports: [TransportOrderCardComponent, LoadCardComponent],
})
export class MonitoringCardsModule {}
